import React, { useEffect, useState } from 'react';

import MasonryLayout from './MasonryLayout';
import Masonic from './Masonic';
import { client } from '../client';
import { feedQuery, searchQuery } from '../utils/data';
import Spinner from './Spinner';
import NoMatchFound from '../assets/NoMatchFound.png';

const Search = ({ searchTerm }) => {
  const [prompts, setPrompts] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (searchTerm !== '') {
      setLoading(true);
      const query = searchQuery(searchTerm.toLowerCase());
      client.fetch(query).then((data) => {
        setPrompts(data);
        setLoading(false);
      });
    } else {
      client.fetch(feedQuery).then((data) => {
        setPrompts(data);
        setLoading(false);
      });
    }
  }, [searchTerm]);

  return (
    <div>

      {loading && <Spinner message="Searching prompts" />}
      {prompts?.length > 0 && <MasonryLayout prompts={prompts} />}
      {/* {prompts?.length > 0 && <Masonic prompts={prompts} />} */}
      {prompts?.length === 0 && searchTerm !== '' && !loading && (
        <div className='flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0'>
        <img src={NoMatchFound} className='w-9/10' alt='logo' />
        <p className='mt-5'>Uh-Oh!</p>
        <p>We are not able to find any results...</p>
      </div>
      )}
    </div>
  );
};

export default Search;